import { Component } from '@angular/core';

@Component({
    selector: 'app-queue',
    templateUrl: './queue.component.html',
    styleUrl: './queue.component.css',
    standalone: false
})
export class QueueComponent {

}
